import { render, staticRenderFns } from "./PaperSettings.vue?vue&type=template&id=3090d582&scoped=true&"
import script from "./PaperSettings.vue?vue&type=script&lang=js&"
export * from "./PaperSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090d582",
  null
  
)

export default component.exports